import { CloudAccountType } from '@repo/api-gw-sdk';
import type { Account, RestoreAccount, SourceAccount } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';
import { getAccountType } from '@/utils/accounts';
import { getAccountInstalledVersion } from '@/utils/roles';

export const useSyncAccountPermissions = (
  onUpdated: (accountId: string) => void,
  setValidationInProgress: (validationInProgress: boolean) => void,
  setHasError: (hasError: boolean) => void,
  account: Account | SourceAccount | RestoreAccount | undefined,
  expectVersionUpdate = true
) => {
  const dal = useDAL();

  const syncAccountPermissions = async () => {
    if (!account) {
      return;
    }

    const accountType = getAccountType(account);
    const installedVersion = getAccountInstalledVersion(account);

    try {
      setValidationInProgress(true);

      const previousInstalledVersion = installedVersion;

      const updatedAccount =
        accountType === CloudAccountType.Source
          ? await dal.cloudAccounts.source.syncPermissions(account.id)
          : accountType === CloudAccountType.Restore
            ? await dal.cloudAccounts.restore.syncPermissions(account.id)
            : undefined;

      const newInstalledVersion = updatedAccount?.installedVersion;

      if (
        expectVersionUpdate &&
        previousInstalledVersion === newInstalledVersion
      ) {
        setHasError(true);
      } else {
        onUpdated(account.id);
      }
    } catch {
      setHasError(true);
    } finally {
      setValidationInProgress(false);
    }
  };

  return {
    syncAccountPermissions,
  };
};
